import { Component, OnInit, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { Entry } from 'contentful';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  animations: [
    trigger('accordion', [
      state('void', style({ overflow: 'hidden', height: 0 })),
      state(':enter', style({ overflow: 'hidden', height: '*' })),
      transition(':leave', animate('.1s')),
      transition(':enter', animate('.1s'))
    ])
  ]
})
export class FaqComponent implements OnInit {
  @Input() public content: Entry<any> | undefined;
  public open: number[] = [];

  constructor() {}

  ngOnInit() {}

  openAccordion(questionAndAnswer: number) {
    this.open.push(questionAndAnswer);
  }

  closeAccordion(questionAndAnswer: number) {
    this.open = this.open.filter(i => i !== questionAndAnswer);
  }

  toggleAccordion(questionAndAnswer: number) {
    this.accordionOpen(questionAndAnswer)
      ? this.closeAccordion(questionAndAnswer)
      : this.openAccordion(questionAndAnswer);
  }

  accordionOpen(questionAndAnswer: number): boolean {
    return this.open.includes(questionAndAnswer);
  }
}
